export default [
  {
    currency: 'USD',
    currencySymbol: '&#36;',
    currencyName: 'United States (US) dollar',
    countries: []
  },
  {
    currency: 'EUR',
    currencySymbol: '&euro;',
    currencyName: 'Euro',
    countries: [
      'AT',
      'BE',
      'BG',
      'CY',
      'CZ',
      'DE',
      'DK',
      'EE',
      'ES',
      'FI',
      'FR',
      'GG',
      'GR',
      'HR',
      'HU',
      'IE',
      'IS',
      'IT',
      'JE',
      'LT',
      'LU',
      'LV',
      'MT',
      'NL',
      'PL',
      'PT',
      'RO',
      'SE',
      'SI',
      'SK'
    ]
  },
  {
    currency: 'CAD',
    currencySymbol: 'C$',
    currencyName: 'Canadian dollar',
    countries: ['CA']
  },
  {
    currency: 'GBP',
    currencySymbol: '&pound;',
    currencyName: 'Pound sterling',
    countries: ['GB']
  }
]
